import { Link } from 'react-router-dom';
import { ArrowLeft, BarChart3, Activity, BellRing, CalendarOff, CreditCard, Crown, FileText, Inbox, KeyRound, Landmark, ListChecks, Mail, Shield, ShieldCheck, Sparkles, UserPlus, Users } from 'lucide-react';

import SidebarLayout from './SidebarLayout';

const adminNavItems = [
  { label: 'Painel Admin', icon: <BarChart3 size={20} />, path: '/app/admin' },
  { label: 'Usuários', icon: <Users size={20} />, path: '/app/admin/usuarios', group: 'Pessoas' },
  { label: 'Planos', icon: <CreditCard size={20} />, path: '/app/admin/planos', group: 'Assinaturas' },
  { label: 'Cortesia', icon: <Crown size={20} />, path: '/app/admin/cortesia', group: 'Assinaturas' },
  { label: 'Whitelist & Convites', icon: <UserPlus size={20} />, path: '/app/admin/whitelist', group: 'Assinaturas' },
  { label: 'IA — Chaves', icon: <Sparkles size={20} />, path: '/app/admin/ia', group: 'Infraestrutura' },
  { label: 'Integrações', icon: <ShieldCheck size={20} />, path: '/app/admin/monitoramento', group: 'Infraestrutura' },
  { label: 'Jobs', icon: <ListChecks size={20} />, path: '/app/admin/jobs', group: 'Infraestrutura' },
  { label: 'Logs', icon: <Activity size={20} />, path: '/app/admin/observabilidade', group: 'Infraestrutura' },
  { label: 'Outbox', icon: <Inbox size={20} />, path: '/app/admin/outbox', group: 'Infraestrutura' },
  { label: 'Auditoria LGPD', icon: <Shield size={20} />, path: '/app/admin/auditoria', group: 'Infraestrutura' },
  { label: 'Certificados de Serviço', icon: <KeyRound size={20} />, path: '/app/admin/certificados-servico', group: 'Infraestrutura' },
  { label: 'Fontes dos Tribunais', icon: <Landmark size={20} />, path: '/app/admin/fontes-tribunais', group: 'Infraestrutura' },
  { label: 'Calendário Forense', icon: <CalendarOff size={20} />, path: '/app/admin/calendario-forense', group: 'Prazos' },
  { label: 'Templates', icon: <FileText size={20} />, path: '/app/admin/templates', group: 'Comunicação' },
  { label: 'Fila de Emails', icon: <Mail size={20} />, path: '/app/admin/emails', group: 'Comunicação' },
  { label: 'Notificações Push', icon: <BellRing size={20} />, path: '/app/admin/notificacoes', group: 'Comunicação' },
];

function AdminLayout() {
  return (
    <SidebarLayout
      navItems={adminNavItems}
      sidebarClassName="sidebar-admin"
      headerExtra={
        <Link
          to="/app"
          className="flex items-center gap-2 px-3 py-2 text-sm text-[var(--color-text-secondary)] transition-colors hover:text-[var(--color-text-primary)]"
        >
          <ArrowLeft size={16} />
          Voltar ao aplicativo
        </Link>
      }
    />
  );
}

export default AdminLayout;
